import { formatBytes } from '@pu/mpp-ui';
import { ICustomFile } from '@pu/mpp-ui/components/form';
import * as yup from 'yup';
import { exceedingMaxFileSize, fileMustBe } from 'core/constants/error-messages.constants';

export const getFileExtension = (file: File) => {
  if (!file) throw Error('File should not be undefined or null');
  return file.name.split('.').pop();
};

export const getFileNameAfterFirstSpace = (url: string, prefix = ''): string =>
  // Extract file name from path, then get the part after the prefix
  url.replace(/^.*[\\/]/, '').replace(new RegExp(`^${prefix}`), '');

export const MIME_TYPE = {
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
} as const;

export const fileSchema = (fileType: keyof typeof MIME_TYPE, maxSizeInBytes: number) => {
  const maxFileSize = formatBytes(maxSizeInBytes).replace(' ', '');

  return yup
    .mixed()
    .test('fileType', fileMustBe(fileType), file => {
      const value = (file as ICustomFile)?.blob;

      if (!value) {
        return true;
      }

      const isFile = value instanceof File;

      const isXLSX = isFile && (value.type === MIME_TYPE[fileType] || value.name.toLowerCase().endsWith('.xlsx'));

      return isXLSX;
    })
    .test('fileSize', exceedingMaxFileSize(maxFileSize), file => {
      const value = file as File;

      if (!value) {
        return true;
      }

      const isFile = value instanceof File;

      const isValidSize = isFile && value.size <= maxSizeInBytes;

      return isValidSize;
    });
};
